import React, { lazy } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { getProfile } from '../../selectors';

class PrivateRoute extends React.Component {
  render() {
    const { component: Component, profile: profile, path, ...rest } = this.props

    let isChannelComponent = false;
    
    console.log("path", path)

    if (path.indexOf("channels") > -1)
      isChannelComponent = true;

    return (
      <Route {...rest} render={(props) => {
        if (profile && profile.features && profile.features.multiregion && profile.multiregion_switch) {
          // console.log('==============', profile.multiregion_switch);
          localStorage.setItem('multiregion_switch', profile.multiregion_switch);
        } else
          localStorage.setItem('multiregion_switch', "false");

        if (
          (path === '/client-users-create' || path === '/client-users')
          && profile && !profile.is_client_admin
        ) {
          return <Redirect to="/assets" />
        }

        if (isChannelComponent && profile && !(profile.features && profile.features.multiregion && profile.multiregion_switch)) {
          return <Redirect to="/assets" />
        }

        return <Component {...props} />
      }
      } />
    )
  }
}

const mapStateToProps = state => ({
  profile: getProfile(state)
});

export default connect(mapStateToProps)(PrivateRoute);




// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/containers/PrivateRoute/index.js